import { Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { of } from 'rxjs';
import { FORMLY_FIELD_VALIDATORS, FORMLY_FIELD_WRAPPERS } from '@app/constants';
import { LocalUseField } from '@app/shared/components/local-use-data-entry/models/LocalUseField.model';
import { LocalUseFieldGroup } from '@app/shared/components/local-use-data-entry/models/localUseFieldGroup.model';

@Injectable()
export class LocalUseFieldConfigProvider {
	public get(fields: LocalUseField[]): FormlyFieldConfig[] {
		const groups: LocalUseFieldGroup[] = fields
			.filter((field) => field.Active)
			.map((field) => field.GroupName)
			.filter((field, index, self) => self.indexOf(field) === index)
			.map((groupName) => ({
				fields: fields.filter((field) => field.GroupName === groupName).sort((field) => field.Priority),
				updatingName: false,
				groupName,
			}))
			.sort((a, b) => a.groupName.toLowerCase().localeCompare(b.groupName.toLowerCase()));
		return groups.map(
			(group: LocalUseFieldGroup): FormlyFieldConfig => ({
				key: 'localUse',
				wrappers: [FORMLY_FIELD_WRAPPERS.section],
				templateOptions: {
					label: group.groupName,
					section: group.groupName,
				},
				fieldGroupClassName: 'row full',
				fieldGroup: this.getGroupFieldsConfig(group.fields),
			})
		);
	}

	public getGroupFieldsConfig(fields: LocalUseField[]): FormlyFieldConfig[] {
		return fields
			.filter((field) => field.Active)
			.map((field) => ({
				key: field.Id.toString(),
				className: 'col-md-2 col-sm-4 col-xs-6',
				type: this.getFieldType(field),
				templateOptions: {
					label: field.FieldName,
					required: field.Required,
					disabled: false,
					readonly: false,
					loadImmediately: true,
					options: field.isAutocomplete ? field.ListOfValues.map((value) => ({ label: value, value })) : [],
					filter: (value: string) =>
						of(
							value
								? field.ListOfValues.filter((val) => val.toLowerCase().indexOf(value.toLowerCase()) === 0)
								: field.ListOfValues.slice()
						),
				},
				validators: {
					validation: field.Required ? [FORMLY_FIELD_VALIDATORS.requiredNoWhitespace] : [],
				},
			}));
	}

	private getFieldType(field: LocalUseField): string {
		if (field.LimitToList) {
			return 'select';
		}

		if (field.isAutocomplete) {
			return 'autocomplete';
		}

		return 'textarea';
	}

	public getFormValueFromFields = (fields: LocalUseField[]): any =>
		fields.reduce((result, field) => ({ ...result, [field.Id]: field.FieldValue }), {});
}
